import { createPaginatedRequestAtom, createRequestAtom } from '../../../shared/utils/request-atom';
import { cxOverview, cxOverviewPaginationData } from '../typings';

export const cxOverviewAtom = createPaginatedRequestAtom<cxOverview, cxOverviewPaginationData>({
  loading: false,
});

export const isCxIssueEnabledAtom = createRequestAtom<{ enabled: boolean }>();
